import type { CityConfig } from "../city-template/types";

export const fortDodgeConfig: CityConfig = {
  vitalRecordsIcon: "ri-file-text-line",
  vitalRecordsLinks: [
    { icon: "ri-file-text-line", label: "Iowa HHS Vital Records (Birth, Death, Marriage)", url: "https://hhs.iowa.gov/vital-records", desc: "Official Iowa vital records office in Des Moines" },
    { icon: "ri-heart-pulse-line", label: "Webster County Recorder — Marriage Licenses", url: "https://www.webstercountyia.gov/recorder", desc: "Webster County Recorder — marriage license issuance" },
    { icon: "ri-scales-line", label: "Iowa Courts — Divorce Records", url: "https://www.iowacourts.gov/", desc: "Iowa Judicial Branch — divorce decree records" },
    { icon: "ri-global-line", label: "VitalChek — Order Vital Records Online", url: "https://www.vitalchek.com/", desc: "Official partner of Iowa HHS for online vital record orders" },
  ],
  city: "Fort Dodge",
  state: "Iowa",
  stateAbbr: "IA",
  slug: "fort-dodge",
  route: "/cities/fort-dodge",
  title: "Emergency Passport Fort Dodge, IA — Expedited & Fast Passport Service | Fast Passport Center",
  metaDescription: "Emergency and expedited passport services in Fort Dodge, IA — as fast as 24 hours. Serving Webster County and North Central Iowa. A+ BBB rated registered State Dept. courier serving agribusiness travelers, medical professionals, and North Central Iowa families. No office visit required.",
  h1: "Emergency & Expedited Passport Services in Fort Dodge, IA",
  heroSubtitle: "Agribusiness trip to Brazil and your passport expired? Medical mission to Guatemala leaving next week? Dodge City Days cruise and your documents aren't ready? We help Fort Dodge and North Central Iowa residents get their passports fast — as fast as 24 hours. A+ BBB rated registered State Dept. courier. Best price guarantee. No office visit required.",
  heroImageUrl: "https://readdy.ai/api/search-image?query=Fort%20Dodge%20Iowa%20historic%20downtown%20district%20along%20the%20Des%20Moines%20River%20with%20gypsum%20mining%20heritage%20and%20North%20Central%20Iowa%20prairie%20landscape%20at%20golden%20hour%20warm%20sunlight%20professional%20photography%20vibrant%20agricultural%20region&width=1800&height=700&seq=fort-dodge-hero-ia-2026&orientation=landscape",
  heroImageAlt: "Fort Dodge Iowa historic downtown Des Moines River North Central Iowa at golden hour",
  geoPosition: "42.4975;-94.1680",
  geoPlacename: "Fort Dodge, Iowa",
  lastModified: "2026-06-14",
  regionalAgency: {
    name: "Chicago Passport Agency",
    address: "101 Ida B Wells Dr, 9th Floor, Chicago, IL 60604",
    distance: "Located in the Chicago Loop — approximately 340 miles east of Fort Dodge via US-20 and I-88",
  },
  nearbyCitiesZips: [
    { name: "Fort Dodge", zips: "50501" },
    { name: "Webster City", zips: "50595" },
    { name: "Humboldt", zips: "50548" },
    { name: "Eagle Grove", zips: "50533" },
    { name: "Clarion", zips: "50525" },
    { name: "Manson", zips: "50563" },
    { name: "Gowrie", zips: "50543" },
    { name: "Rockwell City", zips: "50579" },
    { name: "Pocahontas", zips: "50574" },
    { name: "Algona", zips: "50511" },
    { name: "Storm Lake", zips: "50588" },
    { name: "Carroll", zips: "51401" },
    { name: "Jefferson", zips: "50129" },
    { name: "Boone", zips: "50036" },
    { name: "Ames", zips: "50010–50014" },
    { name: "Mason City", zips: "50401" },
    { name: "Des Moines", zips: "50301–50327" },
    { name: "Waterloo", zips: "50701–50707" },
    { name: "Spencer", zips: "51301" },
    { name: "Sioux City", zips: "51101–51111" },
  ],
  benefits: [
    { icon: "ri-time-line", title: "24–48 Hour Processing", desc: "Emergency courier submission for urgent North Central Iowa departures" },
    { icon: "ri-shield-check-line", title: "Registered Courier", desc: "U.S. Department of State approved passport expediting" },
    { icon: "ri-user-line", title: "Dedicated Agent", desc: "A real person assigned to your case from start to finish" },
    { icon: "ri-map-pin-2-line", title: "NC Iowa Coverage", desc: "Serving Webster, Hamilton, Humboldt, Calhoun, and surrounding counties" },
  ],
  internalLinks: [
    { name: "Expedited passport services in Des Moines, IA", route: "/cities/des-moines" },
    { name: "Fast passport renewal in Ames, IA", route: "/cities/ames" },
    { name: "Emergency passport help in Mason City, IA", route: "/cities/mason-city" },
    { name: "Urgent passport services in Waterloo, IA", route: "/cities/waterloo-ia" },
    { name: "Same-day passport help in Sioux City, IA", route: "/cities/sioux-city" },
    { name: "Passport courier services in Cedar Rapids, IA", route: "/cities/cedar-rapids" },
  ],
  fpcOfficeNote: "Fast Passport Center serves Fort Dodge remotely via secure courier. We do not have a walk-in office in Fort Dodge — our registered couriers hand-deliver your documents directly to U.S. Department of State processing facilities. This is how we achieve 24–48 hour turnaround for Webster County and the entire North Central Iowa region.",
  fpcOfficeAddress: "525 N Tryon St., Charlotte, NC 28202",
  fpcOfficeDistance: "Serving all of Webster County and the North Central Iowa region including Hamilton, Humboldt, Calhoun, Pocahontas, Kossuth, and Wright counties",
  serviceAreaIntro: "From the gypsum mining heritage and historic downtown of Fort Dodge to the farm communities of Webster City and Humboldt, from the corn and soybean fields of rural Calhoun County to the quiet streets of Clarion and Eagle Grove, from the agribusiness processing centers along the Des Moines River to the wind farms of North Central Iowa — Fast Passport Center serves the entire Fort Dodge region. We regularly help travelers from Fort Dodge, Webster City, Humboldt, Storm Lake, and Algona get their passports fast without the 5.5-hour drive to Chicago.",
  nearbyCitiesIntro: "We serve all Fort Dodge neighborhoods and the surrounding North Central Iowa area including Webster City, Humboldt, Eagle Grove, Clarion, Manson, Gowrie, Rockwell City, Pocahontas, Algona, Storm Lake, Carroll, and Jefferson. If you are anywhere in Webster County, Pocahontas County, or the NC Iowa region, we have you covered.",
  howItWorksIntro: "Most Fort Dodge travelers complete everything online and ship documents overnight. No need to drive to Chicago or wait in line at the regional agency.",
  mistakesIntro: "North Central Iowa travelers often face a 5.5-hour drive to the nearest regional passport agency in Chicago. Here are the most common mistakes that cause delays.",
  testimonialsIntro: "Fort Dodge and Webster County travelers trust us when their departure is days away. Here is what some of them have to say.",
  faqIntro: "Have questions about expedited passports in Fort Dodge? Here are the most common ones we hear from North Central Iowa travelers.",
  statePageRoute: "/states/iowa",
  statePageName: "Iowa",
  dmvWebsite: "https://iowadot.gov/mvd",
  dmvLabel: "Iowa DOT — Motor Vehicle Division",
  stickyNavLinks: [
    { label: "Processing", href: "#processing-options" },
    { label: "Services", href: "#services" },
    { label: "Service Area", href: "#service-area" },
    { label: "Facilities", href: "#acceptance-facilities" },
    { label: "Comparison", href: "#comparison" },
    { label: "How It Works", href: "#how-it-works" },
    { label: "FAQ", href: "#faq" },
    { label: "Resources", href: "#local-resources" },
  ],
  processingOptions: [
    {
      speed: "2–9",
      unit: "Business Days",
      label: "Fast Passport Center",
      tag: "Most Popular",
      tagColor: "bg-[#F6C344] text-[#1A365D]",
      features: [
        "Registered U.S. Department of State Courier",
        "Reserved agency submission",
        "Predictable turnaround",
        "Ideal for upcoming trips",
        "Document review included",
        "Dedicated agent assigned to your case",
        "Daily status updates — never left guessing",
        "Not affected by government shutdowns",
      ],
      highlight: true,
    },
    {
      speed: "3–5",
      unit: "Weeks",
      label: "Fast Passport Center",
      tag: "Standard Expedited",
      tagColor: "bg-[#1A365D]/10 text-[#1A365D]",
      features: [
        "Registered U.S. Department of State Courier",
        "Reserved agency submission",
        "Faster than self-service",
        "Good for planned travel",
        "Document review included",
        "Dedicated agent assigned to your case",
        "Daily status updates — never left guessing",
        "Not affected by government shutdowns",
      ],
      highlight: false,
      smartSaver: true,
    },
    {
      speed: "1–2",
      unit: "Months",
      label: "Self-Service (Post Office)",
      tag: "Slowest",
      tagColor: "bg-gray-100 text-gray-400",
      features: [
        "No courier access — standard mail only",
        "Workload & wait times shift with shutdowns",
        "In-person clerk appointment required",
        "No document review — errors cause rejection",
        "No dedicated agent — you are on your own",
        "Updates only by physical mail letter",
        "No phone or email contact for your case",
        "Can't upgrade speed after submission",
        "Not suitable if travel is within 10 weeks",
      ],
      highlight: false,
      muted: true,
    },
    {
      speed: "24",
      unit: "Hours*",
      label: "Regional Agency Processing",
      tag: "Emergency Only",
      tagColor: "bg-gray-100 text-gray-500",
      features: [
        "Appointment required — no walk-ins allowed",
        "Life-or-death emergencies only",
        "Bereavement or medical crisis",
        "Expect to wait all day or return next day",
      ],
      highlight: false,
      emergency: true,
    },
  ],
  services: [
    {
      icon: "ri-flashlight-line",
      title: "Emergency Passport",
      description: "For Fort Dodge travelers with immediate departure needs — as fast as 24 hours for urgent international flights.",
      bullets: ["24–48 hour turnaround available", "Registered courier hand-delivery", "Flight verification support"],
      badge: "Most Popular",
      link: "https://fastpassportcenter.com/checkout/?passport=new-passport",
    },
    {
      icon: "ri-passport-line",
      title: "Passport Renewal",
      description: "Fast renewal for adults with a passport issued within the last 15 years at age 16 or older.",
      bullets: ["No clerk visit required for most", "Mail-in or courier options", "Lost passport replacement available"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=passport-renewal",
    },
    {
      icon: "ri-add-circle-line",
      title: "New Passport",
      description: "First-time passport application guidance with acceptance clerk appointment support.",
      bullets: ["Acceptance facility locator", "Form DS-11 assistance", "Photo requirement guidance"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=new-passport",
    },
    {
      icon: "ri-alert-line",
      title: "Lost or Stolen Passport",
      description: "Passport replacement with DS-64 form guidance and police report documentation.",
      bullets: ["DS-64 form assistance", "Identity verification support", "Emergency replacement options"],
      badge: "Urgent",
      link: "https://fastpassportcenter.com/checkout/?passport=lost-stolen-passport",
    },
    {
      icon: "ri-parent-line",
      title: "Child Passport",
      description: "Passport services for minors under 16 with parental consent and acceptance clerk support.",
      bullets: ["DS-11 form for minors", "Parental consent guidance", "Both parents presence rules"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=child-passport",
    },
    {
      icon: "ri-file-edit-line",
      title: "Name Change",
      description: "Passport correction and name change service after marriage, divorce, or legal changes.",
      bullets: ["DS-5504 or DS-82 guidance", "Marriage certificate support", "Court order documentation"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=name-change",
    },
    {
      icon: "ri-bank-card-line",
      title: "Passport Card",
      description: "Wallet-sized U.S. Passport Card for land and sea travel to Canada, Mexico, Bermuda, and the Caribbean.",
      bullets: ["REAL ID compliant alternative", "Fits in your wallet", "Land/sea border crossing approved"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=passport-card",
    },
    {
      icon: "ri-error-warning-line",
      title: "Damaged Passport",
      description: "Replacement for water-damaged, torn, or otherwise mutilated passports that are no longer valid for travel.",
      bullets: ["Damage assessment guidance", "DS-11 replacement process", "Supporting documentation help"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=damaged-passport",
    },
    {
      icon: "ri-file-copy-line",
      title: "Second Passport",
      description: "Obtain a second valid U.S. passport for frequent international travelers who need overlapping visas.",
      bullets: ["For frequent business travelers", "Overlapping visa support", "Expedited processing available"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=second-passport",
    },
  ],
  servicesSchema: [
    { name: "Emergency Passport", description: "Urgent passport processing for travelers with immediate departure needs, as fast as 24 hours." },
    { name: "Passport Renewal", description: "Fast passport renewal for U.S. citizens with a passport issued within the last 15 years at age 16 or older." },
    { name: "New Passport", description: "First-time passport application assistance with step-by-step guidance through the acceptance clerk process." },
    { name: "Lost or Stolen Passport", description: "Passport replacement service for lost or stolen passports, including DS-64 form guidance." },
    { name: "Child Passport", description: "Passport services for minors under 16, with parental consent guidance and acceptance clerk support." },
    { name: "Name Change", description: "Passport correction and name change service after marriage, divorce, or legal name changes." },
    { name: "Passport Card", description: "Wallet-sized U.S. Passport Card for land and sea travel to Canada, Mexico, Bermuda, and the Caribbean." },
    { name: "Damaged Passport", description: "Replacement for water-damaged, torn, or mutilated passports requiring DS-11 replacement." },
    { name: "Second Passport", description: "Second valid U.S. passport for frequent international travelers with overlapping visa needs." },
  ],
  testimonials: [
    {
      name: "Randy J.",
      location: "Fort Dodge, IA",
      rating: 5,
      text: "Agribusiness trip to Brazil and my passport expired. Fast Passport Center renewed it in 3 days. No way I was driving 5+ hours to Chicago. They saved the whole deal.",
      service: "Passport Renewal",
    },
    {
      name: "Nancy B.",
      location: "Webster City, IA",
      rating: 5,
      text: "Medical mission trip to Honduras leaving in 4 days. Fast Passport Center had my emergency passport in 28 hours. My colleagues couldn't believe how fast it was.",
      service: "Emergency Passport",
    },
    {
      name: "Tom H.",
      location: "Fort Dodge, IA",
      rating: 5,
      text: "First passports for my three kids before a family reunion in Ireland. Fast Passport Center handled all the DS-11 applications and got them back in 5 days. Incredible service for NC Iowa families.",
      service: "Child Passport",
    },

  ],
  facilities: [
    {
      id: "fd-1",
      name: "Fort Dodge Post Office",
      type: "USPS Passport Acceptance Facility",
      address: "517 Central Ave",
      city: "Fort Dodge",
      state: "IA",
      zip: "50501",
      phone: "(515) 573-1717",
      hours: "Mon–Fri: 9:00 AM – 4:00 PM",
      distance: "Downtown Fort Dodge",
      website: "https://tools.usps.com/find-location.htm",
      websiteLabel: "USPS Location Finder",
      notes: "Primary Fort Dodge facility. Appointments strongly recommended. Call ahead to confirm passport acceptance hours.",
      icon: "ri-mail-line",
    },
    {
      id: "fd-2",
      name: "Webster County Recorder's Office",
      type: "County Recorder Passport Acceptance",
      address: "701 Central Ave",
      city: "Fort Dodge",
      state: "IA",
      zip: "50501",
      phone: "(515) 573-3211",
      hours: "Mon–Fri: 8:00 AM – 4:30 PM",
      distance: "Downtown Fort Dodge Courthouse",
      website: "https://www.webstercountyia.gov/recorder",
      websiteLabel: "Webster County Recorder",
      notes: "Accepts passport applications. Good alternative to post office with extended hours.",
      icon: "ri-government-line",
    },
    {
      id: "fd-3",
      name: "Webster City Post Office",
      type: "USPS Passport Acceptance Facility",
      address: "801 Des Moines St",
      city: "Webster City",
      state: "IA",
      zip: "50595",
      phone: "(515) 832-2511",
      hours: "Mon–Fri: 9:00 AM – 4:00 PM",
      distance: "25 miles east of Fort Dodge",
      website: "https://tools.usps.com/find-location.htm",
      websiteLabel: "USPS Location Finder",
      notes: "Serves Hamilton County. Full passport services available.",
      icon: "ri-mail-line",
    },
    {
      id: "fd-4",
      name: "Ames Post Office",
      type: "USPS Passport Acceptance Facility",
      address: "525 Kellogg Ave",
      city: "Ames",
      state: "IA",
      zip: "50010",
      phone: "(515) 232-1912",
      hours: "Mon–Fri: 9:00 AM – 4:00 PM",
      distance: "70 miles southeast of Fort Dodge",
      website: "https://tools.usps.com/find-location.htm",
      websiteLabel: "USPS Location Finder",
      notes: "Serves Story County and Iowa State University community. Full passport services.",
      icon: "ri-mail-line",
    },
    {
      id: "fd-5",
      name: "Storm Lake Post Office",
      type: "USPS Passport Acceptance Facility",
      address: "509 Erie St",
      city: "Storm Lake",
      state: "IA",
      zip: "50588",
      phone: "(712) 732-2821",
      hours: "Mon–Fri: 9:00 AM – 4:00 PM",
      distance: "65 miles northwest of Fort Dodge",
      website: "https://tools.usps.com/find-location.htm",
      websiteLabel: "USPS Location Finder",
      notes: "Serves Buena Vista County. Full passport services available.",
      icon: "ri-mail-line",
    },
    {
      id: "fd-6",
      name: "Mason City Post Office",
      type: "USPS Passport Acceptance Facility",
      address: "211 N Delaware Ave",
      city: "Mason City",
      state: "IA",
      zip: "50401",
      phone: "(641) 423-5211",
      hours: "Mon–Fri: 9:00 AM – 4:00 PM",
      distance: "85 miles northeast of Fort Dodge",
      website: "https://tools.usps.com/find-location.htm",
      websiteLabel: "USPS Location Finder",
      notes: "Largest North Iowa facility. Serves Cerro Gordo County. Full passport services.",
      icon: "ri-mail-line",
    },
  ],
  comparisonRows: [
    { feature: "Appointment Needed", agency: "Yes — call NPIC, limited slots", fpc: "No — we handle everything for you" },
    { feature: "Processing Speed", agency: "Same-day if approved (rare)", fpc: "24–48 hours guaranteed for emergency" },
    { feature: "Document Review", agency: "No — rejected if wrong", fpc: "Yes — we check before submission" },
    { feature: "Travel to Agency", agency: "Yes — 5.5 hour drive to Chicago", fpc: "No — ship from home or office" },
    { feature: "Agent Support", agency: "No — government clerk only", fpc: "Yes — dedicated agent assigned" },
    { feature: "Status Updates", agency: "No — no tracking provided", fpc: "Yes — daily email updates" },
    { feature: "Guaranteed Timing", agency: "No — subject to availability", fpc: "Yes — contractual turnaround times" },
    { feature: "Courier Service", agency: "Not available — self-transport only", fpc: "Registered courier hand-delivers documents" },
    { feature: "Photo Services", agency: "Not available at agency — must bring own", fpc: "Photo review and guidance included" },
  ],
  mistakes: [
    {
      icon: "ri-image-line",
      title: "Wrong Photo Size or Background",
      description: "NC Iowa photo shops often use generic sizes. Passport photos must be exactly 2×2 inches with a white or off-white background.",
    },
    {
      icon: "ri-file-list-line",
      title: "Incomplete DS-11 Form",
      description: "Missing signatures or using the wrong form type are the #1 reasons for rejection at Webster County acceptance facilities.",
    },
    {
      icon: "ri-money-dollar-circle-line",
      title: "Wrong Payment Amount",
      description: "Fees change frequently. Many NC Iowa applicants show up with incorrect payment and have to reschedule their appointment.",
    },
    {
      icon: "ri-calendar-close-line",
      title: "No Proof of Travel",
      description: "Without flight confirmation or travel itinerary, the Chicago regional agency will turn you away for emergency appointments.",
    },
    {
      icon: "ri-parent-line",
      title: "Missing Parental Consent",
      description: "For minors, both parents must appear or submit notarized consent. This trips up many NC Iowa families at the county clerk.",
    },
    {
      icon: "ri-time-line",
      title: "Waiting Too Long to Start",
      description: "Fort Dodge travelers often assume standard processing will be fine. It takes 8–11 weeks. Start expedited at least 3 weeks before travel.",
    },
  ],
  steps: [
    { number: "1", icon: "ri-file-list-line", title: "Apply Online", description: "Complete your application on our secure website in under 10 minutes." },
    { number: "2", icon: "ri-mail-send-line", title: "Ship Documents", description: "We send you a prepaid overnight label. Drop your documents at any UPS location in Fort Dodge." },
    { number: "3", icon: "ri-shield-check-line", title: "We Review", description: "Our team checks every document for accuracy before hand-delivering to the State Department." },
    { number: "4", icon: "ri-passport-line", title: "Processing", description: "Your passport is processed at a U.S. Department of State facility using our registered courier slots." },
    { number: "5", icon: "ri-truck-line", title: "Delivery", description: "We overnight your new passport back to your Fort Dodge address — trackable every step of the way." },
  ],
  faqs: [
    { q: "Can I get an emergency passport in Fort Dodge before international travel?", a: "Yes. Fast Passport Center provides emergency passport services in Fort Dodge for travelers with urgent international flights. Our registered couriers hand-deliver your documents directly to U.S. Department of State facilities, achieving 24–48 hour turnaround — without the 5.5-hour drive to Chicago." },
    { q: "How fast can I renew my passport in Fort Dodge?", a: "Fast Passport Center offers fast passport renewal in Fort Dodge in as little as 24–48 hours through our emergency courier service. For less urgent travel, our 3–5 day expedited option provides the best value. Both options include full document review and a dedicated agent." },
    { q: "What is the closest passport agency to Fort Dodge?", a: "The nearest regional passport agency to Fort Dodge is the Chicago Passport Agency, approximately 340 miles east via US-20 and I-88. For urgent processing without the long drive, Fast Passport Center's registered courier service achieves 24–48 hour turnaround from Fort Dodge without any in-person agency visit required." },
    { q: "Can I get a same-day passport appointment near Fort Dodge?", a: "Same-day passport appointments are only available at the Chicago Regional Passport Agency — approximately 5.5 hours from Fort Dodge — for documented life-or-death emergencies. For all other urgent travel, Fast Passport Center's 24–48 hour emergency courier processing is the fastest guaranteed option for Webster County and NC Iowa residents." },
    { q: "Do you serve the entire North Central Iowa region?", a: "Absolutely. Fast Passport Center serves the entire North Central Iowa region including Fort Dodge, Webster City, Humboldt, Eagle Grove, Clarion, Algona, Storm Lake, Carroll, and surrounding communities. Our courier service works seamlessly from any address in Webster County, Pocahontas County, and NC Iowa." },
    { q: "Can I expedite a child passport in Fort Dodge?", a: "Yes. Fast Passport Center expedites child passports in Fort Dodge for minors under 16. Both parents must appear or submit notarized consent, along with the child's birth certificate and both parents' IDs. We walk NC Iowa families through the entire process." },
    { q: "What should I do if I lost my passport before a trip?", a: "If you lost your passport before a trip, contact Fast Passport Center immediately. We provide lost passport replacement services in Fort Dodge with DS-64 form guidance and identity verification support. Our emergency courier service can get your replacement passport in 24–48 hours." },
    { q: "Do I need to drive to the Chicago Passport Agency?", a: "No. With Fast Passport Center, you complete everything online and ship your documents overnight. Our couriers handle the in-person delivery to State Department facilities. You only need to visit a local acceptance clerk if you're a first-time applicant or need a name change." },
  ],
  photoLocations: [
    { name: "CVS Pharmacy — Fort Dodge", address: "2928 5th Ave S, Fort Dodge, IA 50501", hours: "Mon–Sun: 8AM–10PM", website: "https://www.cvs.com/store-locator" },
    { name: "Walgreens — Fort Dodge", address: "2910 1st Ave S, Fort Dodge, IA 50501", hours: "Mon–Sun: 7AM–11PM", website: "https://www.walgreens.com/storelocator" },
    { name: "Walmart Supercenter — Fort Dodge", address: "3036 1st Ave S, Fort Dodge, IA 50501", hours: "Mon–Sun: 6AM–11PM", website: "https://www.walmart.com/store/finder" },
    { name: "Walgreens — Webster City", address: "839 2nd St, Webster City, IA 50595", hours: "Mon–Sun: 7AM–11PM", website: "https://www.walgreens.com/storelocator" },
    { name: "CVS Pharmacy — Ames", address: "2801 Grand Ave, Ames, IA 50010", hours: "Mon–Sun: 8AM–10PM", website: "https://www.cvs.com/store-locator" },
    { name: "FedEx Office — Ames", address: "1312 S Duff Ave, Ames, IA 50010", hours: "Mon–Fri: 7AM–9PM, Sat: 8AM–6PM", website: "https://www.fedex.com/en-us/location.html" },
  ],
  dmvLocations: [
    {
      name: "Iowa DOT — Fort Dodge Driver's License",
      address: "2724 5th Ave S, Fort Dodge, IA 50501",
      hours: "Mon–Fri: 8AM–5PM",
      note: "Driver license and REAL ID services for Webster County. Appointment recommended.",
      featured: true,
    },
    {
      name: "Iowa DOT — Ames Driver's License",
      address: "711 SE 5th St, Ames, IA 50010",
      hours: "Mon–Fri: 8AM–5PM",
      note: "Serves Story County. REAL ID available. Appointment recommended.",
      featured: false,
    },
    {
      name: "Iowa DOT — Mason City Driver's License",
      address: "4049 4th St SW, Mason City, IA 50401",
      hours: "Mon–Fri: 8AM–5PM",
      note: "Serves Cerro Gordo County. REAL ID available.",
      featured: false,
    },
  ],
  airports: [
    {
      code: "FOD",
      name: "Fort Dodge Regional Airport",
      distance: "5 miles north of downtown Fort Dodge",
      address: "1639 Nelson Ave, Fort Dodge, IA 50501",
      note: "Regional airport with daily United Express service to Chicago O'Hare. About 10 minutes from downtown Fort Dodge.",
      flightUrl: "https://www.fortdodgeiowa.org/departments/airport/",
      flightLabel: "FOD Airport",
      featured: true,
    },
    {
      code: "DSM",
      name: "Des Moines International Airport",
      distance: "95 miles south of Fort Dodge",
      address: "5800 Fleur Dr, Des Moines, IA 50321",
      note: "Iowa's largest airport with direct flights nationwide. About 1 hour 30 minutes from Fort Dodge.",
      flightUrl: "https://www.dsmairport.com/",
      flightLabel: "DSM Airport",
      featured: false,
    },
    {
      code: "CID",
      name: "Eastern Iowa Airport",
      distance: "150 miles east of Fort Dodge",
      address: "2121 Arthur Collins Pkwy SW, Cedar Rapids, IA 52404",
      note: "Serves Cedar Rapids and Eastern Iowa. About 2 hours 30 minutes from Fort Dodge.",
      flightUrl: "https://www.eiairport.org/",
      flightLabel: "CID Airport",
      featured: false,
    },
  ],
};